<div class="container animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'Parametros Inicial'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
    <div *ngIf="!loading">
      <!--<div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
        No existen datos para la lista de Parametros Inicial.
      </div>-->
      <div>
        <div class="row">
          <div [class]="'col-md-8'">
            <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
              (keyup)="onQuickFilterChanged()" #quickFilter />
          </div>
          <div [class]="'form-group col-md-4'">
            <button class="btn btn-success btn-block" (click)="callModal()">Agregar</button>
          </div>
        </div>
        <br>
        <hr>
        <ag-grid-angular #agGrid class=" {{uniformeModulo.agGrid.class}}" [ngStyle]="uniformeModulo.agGrid.style"
          id="{{uniformeModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs"
          [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
          >
        </ag-grid-angular>
      </div>
    </div>
  </ng-template>
</div>
<br>

<!-- MODAL CREAR -->
<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Crear Parametro Inicial'" [idButton]="'abrirModal'" [idOpen]="'Modal'"
  [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <form [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('periodo')"
          [placeholder]="'Periodo'" formControlName="periodo" [label]="'Ingrese Periodo*'" [type]="'number'" [id]="'periodo'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codTipoDoc')"
          [placeholder]="'Tipo Documento'" formControlName="codTipoDoc" [label]="'Ingrese Tipo de Documento*'" [type]="'text'" [id]="'codTipoDoc'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codProveedor')"
          [placeholder]="'Código Proveedor'" formControlName="codProveedor" [label]="'Ingrese Código Proveedor*'" [type]="'text'" [id]="'codProveedor'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codCtaDebe')"
          [placeholder]="'Cuenta Debe'" formControlName="codCtaDebe" [label]="'Ingrese Cuenta Debe*'" [type]="'text'" [id]="'codCtaDebe'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codCtaHaber')"
          [placeholder]="'Cuenta Haber'" formControlName="codCtaHaber" [label]="'Ingrese Cuenta Haber*'" [type]="'text'" [id]="'codCtaHaber'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formulario.invalid"
            (click)="agregarParametroIncial()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- MODAL EDITAR -->
<app-lfsa-modal [innTemplate]="enviarModalEditar" [titulo]="'Editar Artículo'" [idButton]="'abrirModalEditar'" [idOpen]="'ModalEditar'"
  [idClose]="'cerrarModalEditar'"></app-lfsa-modal>
<ng-template #enviarModalEditar>
  <form [formGroup]="formularioEditar" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('periodo')"
          [placeholder]="'Periodo'" formControlName="periodo" [label]="'Ingrese Periodo*'" [type]="'number'" [id]="'periodo'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codTipoDoc')"
          [placeholder]="'Tipo Documento'" formControlName="codTipoDoc" [label]="'Ingrese Tipo de Documento*'" [type]="'text'" [id]="'codTipoDoc'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codProveedor')"
          [placeholder]="'Código Proveedor'" formControlName="codProveedor" [label]="'Ingrese Código Proveedor*'" [type]="'text'" [id]="'codProveedor'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codCtaDebe')"
          [placeholder]="'Cuenta Debe'" formControlName="codCtaDebe" [label]="'Ingrese Cuenta Debe*'" [type]="'text'" [id]="'codCtaDebe'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codCtaHaber')"
          [placeholder]="'Cuenta Haber'" formControlName="codCtaHaber" [label]="'Ingrese Cuenta Haber*'" [type]="'text'" [id]="'codCtaHaber'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioEditar.invalid"
            (click)="editarParametroInicial()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>